import React from "react";
import { Step3ScheduleReserveContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { HeaderBackMusicHallWidget } from "widgets";
import { Displays, Forms, Headers, Navigations } from "components";

class Step3ScheduleReserveContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { router } = this.props;
    this.setState({
      initialValues: {
        ...queryString.parse(router.location.search),
      },
      isLoading: false,
    });
  };

  handleBack = () => {
    const { router } = this.props;
    const { id } = this.props.router.params;
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/condition/2${router.location.search}`,
    );
  };

  handleSubmit = (values) => {
    const { id } = this.props.router.params;
    const queryString = new URLSearchParams(values).toString();
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/4?${queryString}`,
    );
  };

  render() {
    const { router, t } = this.props;
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const { isLoading, initialValues } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Hall Bangkok", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
      },
    ];
    return (
      <Step3ScheduleReserveContainerStyled isPreview={isPreview}>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="step_schedule_reserve_container">
          {!isPreview ? (
            <div className="header_layout">
              <Headers.NewPageHeader
                title={"YAMAHA MUSIC  HALL, BANGKOK"}
                sub_title={"Rental Registration form "}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicHallWidget room_booking_id={router.params.id} />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          <div className="detail_layout">
            <Displays.TitleReserve
              title_reserve={`1. ${t(
                "Contact Information (Event Host/Coordinator)",
                { ns: "room" },
              )}`}
            />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <Forms.MusicHallRegisContactInfoForm
              isDisabledForm={isPreview}
              initialValues={initialValues}
              memberInfo={this.props.authenRedux}
              onBack={this.handleBack}
              onSubmit={this.handleSubmit}
            />
          )}
        </div>
      </Step3ScheduleReserveContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common", "room"])(withRouter(Step3ScheduleReserveContainer)));
